// src/components/Categories.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Categories.css';
import original from '../../../assets/images/categories/neworiginal.png';
import bureau from '../../../assets/images/categories/newbureau.png';
import mobilier from '../../../assets/images/categories/newmobilier.png';
import table from '../../../assets/images/categories/newtable.png';
import comptoire from '../../../assets/images/categories/newcomptoire.png';
import coffreFort from '../../../assets/images/categories/newcoffre.png';
import chaise from '../../../assets/images/categories/newchaise.png';
import categoriesService from '../../../services/categories.service';

const Categories = () => {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(null);
  const [dynamicCategories, setDynamicCategories] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [dropdownRef, setDropdownRef] = useState(null);

  useEffect(() => {
    fetchDynamicCategories();
    
    // Close dropdown when clicking outside
    const handleClickOutside = (event) => {
      if (dropdownRef && !dropdownRef.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [dropdownRef]);

  const fetchDynamicCategories = async () => {
    const result = await categoriesService.getDynamicCategories();
    if (result.success) {
      setDynamicCategories(result.categories);
    }
  };

  // Fixed categories with images - EXACT NAMES MATCHING YOUR NEW CATEGORIES
  const fixedCategories = [
    { 
      id: 1, 
      name: 'Bureau Directionnel', 
      image: bureau,
      color: '#4ECDC4'
    },
    { 
      id: 7, 
      name: 'Bureau Operateur', 
      image: 'chaise',
      color: '#101095ff'
    },
    { 
      id: 2, 
      name: 'Mobilier Métallique', 
      image: mobilier,
      color: '#95A5A6'
    },
    { 
      id: 3, 
      name: 'Tables', 
      image: table,
      color: '#FFD93D'
    },  
    { 
      id: 4, 
      name: 'Comptoir', 
      image: comptoire,
      color: '#E74C3C'
    },
    { 
      id: 5, 
      name: 'Coffre Fort', 
      image: coffreFort,
      color: '#34495E'
    },
    { 
      id: 6, 
      name: 'Chaise', 
      image: chaise,
      color: '#FF6B6B'
    },
    
    { 
      id: 8, 
      name: 'Sofa', 
      image: 'chaise',
      color: '#6b0892ff'
    }
  ];

  const handleCategoryClick = (categoryName) => {
    navigate(`/products?category=${categoryName}`);
  };

  const handleMouseEnter = (categoryId) => {
    setHovered(categoryId);
  };

  const handleMouseLeave = () => {
    setHovered(null);
  };

  const getCurrentCategory = () => {
    return fixedCategories.find(cat => cat.id === hovered);
  };

  const generateParticles = () => {
    return [...Array(6)].map((_, index) => {
      const randomTop = Math.random() * 100;
      const randomLeft = Math.random() * 100;
      const randomX = (Math.random() - 0.5) * 40;
      
      return (
        <div
          key={`particle-${index}`}
          className={`furniture-category-particle ${hovered ? 'furniture-particle-active' : ''}`}
          style={{
            top: `${randomTop}%`,
            left: `${randomLeft}%`,
            backgroundColor: getCurrentCategory()?.color || 'transparent',
            animationDelay: `${index * 0.2}s`,
            '--particle-x': `${randomX}px`,
          }}
        />
      );
    });
  };

  return (
    <section className="furniture-categories-wrapper">
      {/* Main Display Area - Full Screen Background */}
      <div className="furniture-categories-display-area">
        
        {/* Background Image */}
        <div className="furniture-categories-background-layer">
          <img 
            src={original} 
            alt="Fond des catégories" 
            className="furniture-categories-bg-image"
          />
        </div>

        {/* Header Section - Separated */}
        <div className="furniture-categories-header">
          <h2 className="furniture-categories-main-title">Burotime Catégories</h2>
          <div className="furniture-categories-title-divider"></div>
        </div>

        {/* Navigation Buttons - Separated */}
        <div className="furniture-categories-nav-buttons">
          {fixedCategories.map((category) => (
            <button
              key={`nav-${category.id}`}
              className={`furniture-category-nav-btn ${
                hovered === category.id ? 'furniture-category-active' : ''
              }`}
              style={{
                background: hovered === category.id
                  ? `linear-gradient(135deg, ${category.color}, ${category.color}dd)`
                  : 'rgba(255, 255, 255, 0.1)',
                boxShadow: hovered === category.id
                  ? `0 10px 30px ${category.color}66`
                  : 'none',
                backdropFilter: 'blur(10px)',
              }}
              onMouseEnter={() => handleMouseEnter(category.id)}
              onMouseLeave={handleMouseLeave}
              onClick={() => handleCategoryClick(category.name)}
            >
              <span className="furniture-category-nav-btn-text">
                {category.name}
                {hovered === category.id && (
                  <span style={{ animation: 'furniture-float-gentle 1s ease-in-out infinite' }}>
                    ›
                  </span>
                )}
              </span>
              <span
                className="furniture-category-nav-btn-underline"
                style={{
                  backgroundColor: hovered === category.id ? '#ffffff' : category.color,
                }}
              />
            </button>
          ))}

          {/* Autres (Dynamic Categories) Dropdown */}
          {dynamicCategories.length > 0 && (
            <div 
              className="furniture-category-dropdown-wrapper"
              ref={setDropdownRef}
            >
              <button
                className={`furniture-category-nav-btn ${showDropdown ? 'furniture-category-active' : ''}`}
                style={{
                  background: showDropdown
                    ? 'linear-gradient(135deg, #fa28d3ff, #fa28d3dd)'
                    : 'rgba(255, 255, 255, 0.1)',
                  boxShadow: showDropdown
                    ? '0 10px 30px #fa28d366'
                    : 'none',
                  backdropFilter: 'blur(10px)',
                }}
                onClick={() => setShowDropdown(!showDropdown)}
              >
                <span className="furniture-category-nav-btn-text">
                  Autres
                  <svg 
                    className="dropdown-arrow" 
                    style={{ 
                      width: '16px', 
                      height: '16px',
                      transform: showDropdown ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: 'transform 0.3s ease'
                    }}
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2"
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </span>
                <span
                  className="furniture-category-nav-btn-underline"
                  style={{
                    backgroundColor: showDropdown ? '#ffffff' : '#fa28d3ff',
                  }}
                />
              </button>

              {/* Dropdown Menu */}
              {showDropdown && (
                <div className="furniture-category-dropdown-menu">
                  {dynamicCategories.map((category) => (
                    <button
                      key={category.id}
                      className="furniture-category-dropdown-item"
                      onClick={() => handleCategoryClick(category.name)}
                    >
                      {category.name}
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>

        {/* Category Overlay Items - Product Images positioned to match zones */}
        {fixedCategories.map((category) => (
          <div
            key={`overlay-${category.id}`}
            data-category={category.id}
            className={`furniture-category-overlay-item ${
              hovered === category.id ? 'furniture-category-visible' : ''
            }`}
          >
            {/* Radial Glow Background */}
            <div
              className="furniture-category-radial-glow"
              style={{
                background: `radial-gradient(circle at center, ${category.color}22 0%, transparent 70%)`,
              }}
            />

            {/* Product Image Container */}
            <div className="furniture-category-product-wrapper">
              <img
                src={category.image}
                alt={category.name}
                className="furniture-category-product-image"
              />
              
              {/* Glow Effect Behind Product */}
              <div
                className="furniture-category-product-glow-effect"
                style={{
                  background: `radial-gradient(circle, ${category.color} 0%, transparent 70%)`,
                }}
              />
            </div>

            {/* Category Label Badge - Below Product in same zone */}
            {hovered === category.id && (
              <div
                className="furniture-category-label-badge"
                style={{
                  background: `linear-gradient(135deg, ${category.color}, ${category.color}dd)`,
                  boxShadow: `0 10px 40px ${category.color}66`,
                }}
              >
                {category.name}
              </div>
            )}
          </div>
        ))}

        {/* Hover Zones - Individual Positioning for 6 categories */}
        <div className="furniture-categories-hover-zones">
          {fixedCategories.map((category) => (
            <div
              key={`zone-${category.id}`}
              data-category={category.id}
              className="furniture-category-hover-zone"
              onMouseEnter={() => handleMouseEnter(category.id)}
              onMouseLeave={handleMouseLeave}
              onClick={() => handleCategoryClick(category.name)}
            />
          ))}
        </div>

        {/* Floating Particles */}
        {hovered && generateParticles()}

        {/* Bottom Info */}
        <div className="furniture-categories-bottom-info">
          <p className="furniture-categories-info-text">
            Cliquez sur une catégorie pour explorer notre collection
          </p>
        </div>
      </div>
    </section>
  );
};

export default Categories;